import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { HrccService } from './services/hrcc.service';
import { InvestigationService } from './services/investigation.service';
import { PatternInvestigationPopupService } from './services/pattern-investigation-popup.service';
import { SickLeaveListService } from './services/sick-leave-list.service';
import { CommonService } from './services/common.service';
import { PaperflowService } from './services/paperflow.service';
import { ConfigService, ConfigModule } from './services/config.service';


import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { SickLeaveListComponent } from './sick-leave-list/sick-leave-list.component';
import { LeaveListPipe } from './pipes/leave-list.pipe';
import { HrccViewComponent } from './hrcc-view/hrcc-view.component';
import { CorrectionComponent } from './correction/correction.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { CalendarComponent } from './calendar/calendar.component';
import { GroupFilterPipe } from './pipes/group-filter.pipe';
import { InvestigationViewComponent } from './investigation-view/investigation-view.component';
import { PatternInvestigationPopupComponent } from './pattern-investigation-popup/pattern-investigation-popup.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './guard/auth.guard';
import { Angular2Csv } from 'angular2-csv';
import { HttpService } from './services/http.service';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaperflowListComponent } from './paperflow-list/paperflow-list.component';
import { HrccCertificateViewComponent } from './hrcc-certificate-view/hrcc-certificate-view.component';
import { GroupFilterPaperflowPipe } from './pipes/group-filter-paperflow.pipe';
import { SearchAllPaperflowPipe } from './pipes/search-all-paperflow.pipe';
import { NoEmpidListComponent } from './no-empid-list/no-empid-list.component';
import { NoEmpidService } from './services/no-empid.service';
import { GroupFilterCertListPipe } from './pipes/group-filter-cert-list.pipe';
import { NoEmpidComponent } from './no-empid/no-empid.component';
import { NoEmpSearchPipe } from './pipes/no-emp-search.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SickLeaveListComponent,
    LeaveListPipe,
    HrccViewComponent,
    CorrectionComponent,
    SortByPipe,
    CalendarComponent,
    GroupFilterPipe,
    InvestigationViewComponent,
    PatternInvestigationPopupComponent,
    PageNotFoundComponent,
    PaperflowListComponent,
    HrccCertificateViewComponent,
    HomeComponent,
    GroupFilterPaperflowPipe,
    SearchAllPaperflowPipe,
    NoEmpidListComponent,
    GroupFilterCertListPipe,
    NoEmpidComponent,
    NoEmpSearchPipe
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    NgxPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    BsDatepickerModule.forRoot(),
	BrowserAnimationsModule
  ],
  providers: [
    HttpService,
    AuthGuard,
    HrccService,
    PatternInvestigationPopupService,
    InvestigationService,
    SickLeaveListService,
    CommonService,
    ConfigService,
    ConfigModule.init(),
    PaperflowService,
    NoEmpidService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts